import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutorunComponent } from '@myshared/autorun.component';
import { PortOrder } from '@proto/odoo/sessionkv';
import { I18NextService } from 'angular-i18next';
import { MessageService } from 'primeng/api';
import { Company } from 'src/app/company/company.model';
import type { PortOrderDraft } from 'src/app/sessionkv/sessionkv-port-order';
import { SessionKvPortOrderService } from 'src/app/sessionkv/sessionkv-port-order.service';

@Component({
    selector: 'app-phonenumber-port-drafts',
    templateUrl: './phonenumber-port-drafts.component.html',
    standalone: false
})
export class PhonenumberPortDraftsComponent extends AutorunComponent {

    @Input() drafts: PortOrderDraft[] = [];
    @Input() instancename: string;
    @Input() id: string;
    @Input() company: Company;

    @Output() continueDraft = new EventEmitter<PortOrderDraft>();
    @Output() continueNew = new EventEmitter<void>();
    @Output() public readonly backEvent = new EventEmitter();

    constructor(
        private sessionKvPortOrderService: SessionKvPortOrderService,
        private messageService: MessageService,
        private i18n: I18NextService
    ) {
        super();
    }

    
    public onBack() {
        this.backEvent.emit();
    }
    public onContinueDraft(draft: PortOrderDraft) {
        this.continueDraft.emit(draft);
    }

    public onContinueNew() {
        this.continueNew.emit();
    }

    public onDeleteDraft(draft: PortOrderDraft) {
            this.sessionKvPortOrderService.delete(draft.name).subscribe({
                next: () => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: (this.i18n.t('draft_deleted_successfully') as string)
                    });
        
                    this.drafts = this.drafts.filter(d => d.name !== draft.name);

                    if (this.drafts.length === 0) {
                        this.continueNew.emit();
                    }
                }
            });
      }
}
